import React from "react";
import ResponderMap from "features/Responder/features/ResponderMap/index";

const ZoneMapEdit = (props) => (
  <ResponderMap
    enableZones={true}
    enableTools={true}
    enableTourTools={false}
    enableContextMenu={true}
    contextMenuMode="all"
    {...props}
  />
);

export default ZoneMapEdit;
